import React, { useEffect, useRef } from "react";
import { Box } from "rebass/styled-components";

export const ModalClickHandler = ({
  children,
  handleModalClose,
  ...props
}: any) => {
  const clickRef = useRef<any>();

  const handleClickOutside = (e: any) => {
    if (clickRef.current && !clickRef.current.contains(e.target)) {
      handleModalClose();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []); //eslint-disable-line
  return (
    <Box ref={clickRef} {...props}>
      {children}
    </Box>
  );
};
